<template>
  <div>
    <div class="row">
      <div class="col-lg-3 filters-wrapper">
        <div class="filters">
          <div class="block block-fx-pop filter">
            <div class="block-header block-header-default">
              <h3 class="block-title">Zoeken</h3>
            </div>
            <div class="block-content p-0">
              <div class="input-group input-group-lg bg-white">
                <input type="search" class="form-control form-control-alt bg-white border-0 pr-0" placeholder="Zoeken.." v-model="search" />
                <div class="input-group-append">
                  <span class="input-group-text bg-white border-0">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="block block-fx-pop filter pb-3"
            v-for="filter in filters"
            :key="'filter-' + filter.key"
          >
            <div class="block-header block-header-default">
              <h3 class="block-title">{{ filter.name }}</h3>
              <i
                class="fas fa-question-circle ml-2"
                v-if="filter.tooltip"
                data-toggle="tooltip"
                data-placement="top"
                :title="filter.tooltip"
                :data-original-title="filter.tooltip"
              ></i>
            </div>
            <div class="block-content p-0">
              <div class="input-group input-group-sm bg-white" v-if="filter.key == 'package'">
                <input
                  type="text"
                  class="form-control form-control-alt bg-white border-0 pr-0"
                  placeholder="Zoeken.."
                  v-model="filter.search"
                  v-on:keyup="toggleFilterSearch(filter.key, $event)"
                />
                <div class="input-group-append">
                  <span class="input-group-text bg-white border-0">
                    <i class="fas fa-search"></i>
                  </span>
                </div>
              </div>

              <div
                class="dropdown-item"
                v-for="data in filter.visible"
                :key="'value-' + data.value"
                v-on:click.stop.prevent="toggleFilter(filter.key, data)"
              >
                <div class="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    :id="'filter-' + data.value"
                    :name="data.value"
                    :checked="isSelectedFilter(filter.key, data.value)"
                    v-on:change.prevent="toggleFilter(filter.key, data)"
                  />
                  <label class="custom-control-label d-flex align-items-baseline" :for="'filter-' + data.value"
                    >{{ data.name | capitalize }}
                    <i
                      class="fas fa-question-circle ml-2"
                      v-if="data.tooltip"
                      data-toggle="tooltip"
                      data-placement="top"
                      :title="data.tooltip"
                      :data-original-title="data.tooltip"
                    ></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="sites-wrapper">
          <div class="block block-fx-pop" v-if="visiblePackages.length === 0">
            <div class="block-header block-header-default">
              <h3 class="block-title">Actieve linkpakketten</h3>
            </div>
            <div class="block-content">
              <p>
                <template v-if="selectedFilters.length > 0">
                  Er geen actieve linkpakketten die voldoen aan uw zoekopdracht.
                </template>
                <template v-else>
                  U heeft nog geen actieve link(pakketten). Klik <a :href="$route('packages.add')">hier</a> om uw eerste link(pakket) toe te voegen
                </template>
              </p>
            </div>
          </div>
          <bs-package-table-block
            v-for="(group, key) in visiblePackages"
            :key="key"
            :group="group"
            :selectedFilters="selectedFilters"
            :cartItems="cartItems"
          ></bs-package-table-block>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Fuse from 'fuse.js';
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  props: {
    packages: {
      type: Array,
      required: true
    }
  },
  data: () => {
    return {
      search: '',
      visiblePackages: [],
      cartItems: [],
      selectedFilters: [],
      filters: {
        status: {
          key: 'status_name',
          name: 'Status',
          visible: [
            {
              value: 'Binnenkort online',
              name: 'Binnenkort online',
            },
            {
              value: 'Actief',
              name: 'Actief',
            },
            {
              value: 'Verloopt bijna',
              name: 'Verloopt bijna',
              tooltip: '`Verloopt bijna’ zijn links die binnen 60 dagen verlopen',
            },
            {
              value: 'Verlopen',
              name: 'Verlopen',
            },
          ],
        },
        package: {
          key: 'package',
          name: 'Jouw linkpakketten',
          data: [],
          visible: [],
          search: '',
          tooltip: 'Hieronder vindt u al uw huidige linkpakketten',
        },
      },
    };
  },
  watch: {
    cart: function() {
      this.cartItems =  !_.isEmpty(this.cart) ? this.cart.cart_items : [];
    },
    search: function() {
      this.addSearch();
    },
    selectedFilters: function() {
      this.applyPackageFilter();
      this.applyStatusFilter();
      window.One.helpers(['core-bootstrap-tooltip']);
    },
  },
  computed: {
    ...mapState('cart', ['cart']),
  },
  created() {
    this.visiblePackages = this.packages;
    this.filters.package.data = this.packages
      .map((group) => {
        group.links.sort((a, b) => moment(a.expired_at).diff(moment(b.expired_at)))
        return {
          value: group.links[0].user_package_id,
          name: `${group.package.name} - ${this.$options.filters.date(group.links[0].expired_at)}`,
        };
      });
    this.filters.package.visible = this.filters.package.data;
  },
  methods: {
    isSelectedFilter: function(key, value) {
      var index = _.findIndex(this.selectedFilters, (sFilter) => {
        return sFilter.key === key && sFilter.value === value;
      });

      return index >= 0;
    },
    applyPackageFilter() {
      var selectedFilteredPackages = this.selectedFilters
        .filter((filter) => {
          return filter.key === 'package';
        })
        .map((filter) => {
          return this.packages.find((group) => {
            return group.links[0].user_package_id === filter.value;
          });
        });

      this.visiblePackages = selectedFilteredPackages.length > 0 ? selectedFilteredPackages : this.packages;
    },
    applyStatusFilter() {
      var values = this.selectedFilters.filter((selectedFilter) => selectedFilter.key === 'status_name')
        .map((filter) => filter.value);
      
      
      if (values.length > 0) {
        this.visiblePackages = this.visiblePackages.filter((vPackage) => {
          return vPackage.links.some((link) => values.includes(link.status_name));
        })
      }
    },
    addSearch() {
      var index = _.findIndex(this.selectedFilters, (sFilter) => {
        return sFilter.key === 'search';
      });

      if (index >= 0) {
        if (this.search.length === 0) {
          this.removeFilter(index);
        } else {
          this.$set(this.selectedFilters, index, {
            key: 'search',
            label: this.search,
            value: this.search,
          });
        }
      } else if (this.search.length > 0) {
        this.selectedFilters.push({
          key: 'search',
          label: this.search,
          value: this.search,
        });
      }
    },
    toggleFilter(filter, filterobj) {
      var index = _.findIndex(this.selectedFilters, (sFilter) => {
        return sFilter.key === filter && sFilter.value === filterobj.value;
      });

      if (index >= 0) {
        this.selectedFilters.splice(index, 1);
      } else {
        this.selectedFilters.push({
          key: filter,
          value: filterobj.value,
          label: filterobj.name,
        });
      }
    },
    toggleFilterSearch(filter, event) {
      if (event.target.value) {
        var fuse = new Fuse(this.filters[filter].data, {
          threshold: 0.2,
          includeScore: false,
          useExtendedSearch: true,
          keys: ['name'],
        });
        this.filters[filter].visible = fuse.search(event.target.value).map((result) => {
          return result.item;
        });
      } else {
        this.filters[filter].visible = this.filters[filter].data;
      }
    },
    removeFilter(index) {
      this.selectedFilters.splice(index, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.filters-wrapper {
  .search-wrapper {
    height: 80px;
    background: white;
    padding: 0 30px;
    border: 1px solid #eaeaea;
    border-radius: 40px;

    .tags {
      .tag {
        height: 40px;
        padding: 0 15px;
        margin: 0 10px 0 0;
        background: #de7a01;
        color: white;
        border-radius: 6px;
        line-height: 40px;
        font-size: 14px;
        font-weight: bold;
        transition: background 0.3s ease;

        i {
          margin-left: 10px;
          cursor: pointer;
        }
      }
    }

    input {
      height: 70px;
      font-size: 20px;
      border: none;
      outline: none;

      &:focus {
        outline: none;
        box-shadow: none;
      }
    }
  }

  .filters {
    .filter {
      .block-content {
        max-height: 250px;
        overflow-x: hidden;
        overflow-y: auto;
      }
    }
  }
}

@media (max-width: 992px) {
  .sites-wrapper {
    padding-bottom: 80px;
  }
}
</style>
